import { createGlobalStyle } from "styled-components";

export const GlobalNotificationsStyled = createGlobalStyle`
    :root {
      --toastify-color-dark: var(--color-surface);
    }

    .Toastify__toast {
        padding: 8px;
        border-radius: 16px;
        background: var(--color-base-secondary);
        margin: 4px;
        
        .notification-close-button {
            position: absolute;
            right: 8px;
            top: 9px;
            font-size: 12px;
        }
        
        &.background-surface {
            background: var(--color-surface);
        }
    }
    
    .Toastify__toast-body {
        padding: 0;
        &, & > div {
            overflow: hidden;
        }
    }
`;
